import Slide, { Title } from '../../Slide/Slide'
import AcceptPartnerInviteForm from './AcceptPartnerInviteForm/AcceptPartnerInviteForm'
import css from './AcceptPartnerInvite.scss'
import { useNavigate } from 'react-router-dom-v5-compat'

interface AcceptPartnerInviteProps {
  authToken: string
  nextPath: string
}

const AcceptPartnerInvite = ({
  authToken,
  nextPath,
}: AcceptPartnerInviteProps) => {
  const navigate = useNavigate()
  const onSubmitSuccess = () => {
    navigate(nextPath)
  }

  return (
    <Slide>
      <Title className={`mbm ${css.AcceptPartnerInvite__title}`}>
        Welcome to Babylist! 👋
      </Title>
      <p className={`text-center mbl ${css.AcceptPartnerInvite__subtitle}`}>
        Let's start by setting you up with a password.
      </p>
      <AcceptPartnerInviteForm
        authToken={authToken}
        onSubmitSuccess={onSubmitSuccess}
      />
    </Slide>
  )
}

export default AcceptPartnerInvite
